import React from 'react'

const QuoteBlock = ({ text }) => {
  return (
    <q className="block c-small" dangerouslySetInnerHTML={{ __html: text }}></q>
  )
}

export default QuoteBlock
